import styled from "styled-components"
import theme from "styles/theme-main"
import ButtonBase from "@material-ui/core/ButtonBase"
import { isIE } from "utils/utils"

export const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  right: 0px;
  margin: 0 26px 20px 0;
`

export const StyledButton = styled(ButtonBase)`
  && {
    margin: ${props =>
      props.noMargin || (props.attrs && props.attrs.noMargin)
        ? 0
        : "10px 10px 5px 0"};
    height: ${props =>
      props.small ? theme.buttons.heightSmall : theme.buttons.height};
    width: ${props => (props.size === "small" ? "48px" : "48px")};
    border-radius: ${theme.buttons.borderRadius};
    border: none;
    background: ${props =>
      props.disabled
        ? theme.buttons.disabled.background
        : theme.buttons.vantage.background};
    color: ${theme.buttons.vantage.color};
    letter-spacing: 3px;
    text-transform: uppercase;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    transition: width 250ms ease;
    padding: ${props => (props.small ? "0 22px 0 18px;" : "0 21px 0 24px;")};

    :after {
      width: 48px;
      font-weight: bold;
      font-size: 24px;
      color: ${theme.typography.colors.buttonLabel};
      content: "?";
      ${isIE() ? "margin-left: -6px;" : null}
    }

    :focus {
      color: ${theme.typography.colors.buttonLabel};
      width: 216px;
      background: ${theme.buttons.hover.vantage.background};
    }

    :focus:after {
      width: 216px;
      font-size: 14px;
      line-height: 24px;
      color: #ffffff;
      font-weight: 700;
      content: "Report issue";
      white-space: nowrap;
      overflow: hidden;
    }
  }
`
